module.exports = __webpack_public_path__ + "static/media/uniqueuser.454df5a2.png";